<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      button.btn.btn-default(@click="unlockUser" v-if="user && user.locked === true")
        i.fa.fa-unlock
        span.ml5 Unlock User
      router-link.btn.btn-default.edit-user(:to="{name: 'userEdit', params: {id: userId}}")
        i.fa.fa-edit
        span.space-before Edit
      button.btn.btn-default.add-groups(@click="$refs.addGroupModal.open()")
        i.fa.fa-users
        span.space-before Groups
      button.btn.btn-danger.remove-user(@click="removeUser")
        i.fa.fa-eraser
        span.space-before Remove
    UserDetails(ref="userDetails" :user="user" :loading="loading")

    .pull-right.mb10(@click="toggleEdit")
      button.btn.btn-default
        i.fa.fa-edit
        span.space-before {{!editMode ? 'Edit Preferences' : 'Cancel'}}

    .row
      .col-md-12
        .panel.panel-default
          .panel-heading
            .panel-title User Preferences
          .panel-body(v-if="userPreferences")
            .row
              label.col-sm-1 User Id
              .col-sm-4 {{userPreferences.userId}}
              label.col-sm-1 Timezone
              .col-sm-4
                span(v-if="!editMode") {{userPreferences.timezone}}
                TimezonePicker(v-else v-model="timezone")
              .col-sm-1(v-if="editMode")
                button.btn.btn-primary(@click="updateUserPreferences") Save

    AddGroupModal(ref="addGroupModal" @success="$refs.userDetails.reload()" @error="$emit('error', $event)")

</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import PillsList from '@/components/common/PillsList'
import TimezonePicker from '@/components/common/TimezonePicker'
import UserDetails from './UserDetails'
import AddGroupModal from './AddGroupModal'

export default {
  data: () => ({
    userPreferences: null,
    timezone: null,
    editMode: false,
    user: {},
    loading: false
  }),
  created() {
    this.getUserPreferences()
    this.getUser()
  },
  methods: {
    getUser() {
      this.loading = true
      Security.getUser(this.userId)
        .then((resp) => {
          this.user = resp.data.user
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })
    },
    getUserPreferences() {
      Security.getUserPreferences(this.userId)
        .then((resp) => {
          this.userPreferences = resp.data.preferences
        })
    },
    toggleEdit() {
      this.editMode = !this.editMode
    },
    removeUser() {
      this.$confirm({ text: 'Are you sure you want to remove this user?' })
        .then((conf) => {
          if (conf) {
            Security.deleteUser(this.userId, { userId: this.userId })
              .then(() => {
                this.$router.push({ name: 'users' })
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
    unlockUser() {
      this.$confirm({ text: 'Are you sure you want to unlock this user?' })
        .then((conf) => {
          if (conf) {
            Security.unlockUser(this.userId)
              .then(() => {
                miniToastr.success('User unlocked')
                this.getUser()
              })
          }
        })
    },
    updateUserPreferences() {
      const req = {
        preferences: {
          timezone: this.timezone.value,
          userId: this.userId
        }
      }
      Security.updateUserPreferences(this.userId, req)
        .then(() => {
          this.getUserPreferences()
          this.editMode = !this.editMode
        })
    }
  },
  watch: {
    userId() {
      this.getUserPreferences()
      this.getUser()
    }
  },
  computed: {
    userId() {
      return parseInt(this.$route.params.id, 10)
    },
    roles() {
      return this.user.roles.role.map((r) => ({ name: r }))
    }
  },
  components: {
    PillsList,
    UserDetails,
    TimezonePicker,
    AddGroupModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/user/User.vue